var app = angular.module('leonardo');

var SectionBoxedDirective = function(ConfigThemeService, $timeout) {
  return {
    restrict: 'C',
    scope: {
      sectionColor: '@'
    },
    link: function (scope, element) {

      scope.$watch(
        function () {
          return element.attr('class');
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        $timeout(function () {
          var color = scope.sectionColor ? ConfigThemeService.getColor(scope.sectionColor) :
            ConfigThemeService.getColor('secondaryColor', 0.02);
          element.find('.content').css('background-color', color);
        });
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('sectionBoxed', ['ConfigThemeService', '$timeout', SectionBoxedDirective]);
